import React from "react";
import { Alert } from "@akj-dev/shared-components";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";

interface SIMCompatibilityWarningProps {
  handleConfirm: () => void;
  show: boolean;
  affectedNumbers: string[];
}

export const SIMCompatibilityWarning = ({
  handleConfirm,
  show,
  affectedNumbers,
}: SIMCompatibilityWarningProps) => (
  <Dialog open={show}>
    <DialogTitle>Please note:</DialogTitle>
    <DialogContent>
      <Alert
        type="warning"
        message={
          <div>
            <div>
              One or more mobile numbers has been configured with O2 Satellite
              but are not using an eligible SIM. Please complete a SIM swap to
              ensure the O2 Satellite Service works. Affected mobile numbers:
            </div>
            <ul>
              {affectedNumbers.map((number) => (
                <li>
                  <b>{number}</b>
                </li>
              ))}
            </ul>
          </div>
        }
      />
    </DialogContent>
    <DialogActions>
      <Button variant="contained" color="primary" onClick={handleConfirm}>
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
);
